/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "condition--sprite",
  "use": "condition--sprite-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\" id=\"condition--sprite\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17.625 1C11.343 1 6.25 6.093 6.25 12.375c0 2.826 1.033 5.41 2.739 7.399l-7.733 7.732a.875.875 0 1 0 1.237 1.238l7.733-7.733a11.328 11.328 0 0 0 7.4 2.739C23.906 23.75 29 18.657 29 12.375S23.907 1 17.625 1Zm0 21A9.625 9.625 0 0 1 8 12.375a9.625 9.625 0 1 1 19.25 0A9.624 9.624 0 0 1 17.625 22Z\" fill=\"#232323\" stroke=\"#fff\" stroke-width=\".4\" /><path d=\"m23 9.089-6.76 6.76-3.074-3.072\" stroke=\"#232323\" stroke-width=\"1.4\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
sprite.add(symbol);
var viewBoxValues = symbol.viewBox ? symbol.viewBox.split(' ') : []

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox,
      width: viewBoxValues[2],
      height: viewBoxValues[3]
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.width = viewBoxValues[2];
SvgSpriteIcon.height = viewBoxValues[3];
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
